module.exports = __webpack_public_path__ + "img/14.b9dd1203.jpg";